// Debounce
export const DEBOUNCE_SEARCH_DELAY = 250;
export const DEBOUNCE_SLIDER_DELAY = 250;
